module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/lodash/extend.js
// module id = 1040
// module chunks = 1